import { useState } from 'react';
import axios from 'axios';
import {
  GET_EXTENSIONS_URL,
  PAGINATE_EXTENSIONS_URL,
} from '../../../../services/api/shared/extensions/Extensions';

export const useExtensions = () => {
  const [extensions, setExtensions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);

  const getExtensions = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(GET_EXTENSIONS_URL, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      });

      if (response.data) {
        setExtensions(response.data);
      } else {
        setExtensions([]);
      }
    } catch (err) {
      setError(err);
      setExtensions([]);
    } finally {
      setLoading(false);
    }
  };

  const paginateExtensions = async (pageNumber) => {
    setLoading(true);
    setError(null);
    setPage(pageNumber);

    try {
      const response = await axios.get(`${PAGINATE_EXTENSIONS_URL}/${pageNumber}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      });

      if (response.data) {
        setExtensions(response.data);
      } else {
        setExtensions([]);
      }
    } catch (err) {
      setError(err);
      setExtensions([]);
    } finally {
      setLoading(false);
    }
  };

  return {
    extensions,
    setExtensions,
    loading,
    error,
    page,
    setPage,
    getExtensions,
    paginateExtensions,
  };
};
